import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
// eslint-disable-next-line import/default, import/no-named-as-default, import/namespace, import/no-named-as-default-member
import FetchBackend from "i18next-fetch-backend";

// eslint-disable-next-line import/no-named-as-default-member
i18n
  .use(FetchBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    defaultLng: "en",
    //debug: true,
    load: "languageOnly",
    ns: ["common", "Navigation", "Dashboard", "Stats", "Tryps", "LevelUp", "CampaignInfo", "CampaignBuilder"],
    fallbackNS: "common",
    defaultNS: "common",
    backend: {
      loadPath: "/locales/{{lng}}/{{ns}}.json",
    },
    returnObjects: true,
  });

i18n.services.formatter.add("capitalize", (value) =>
  value
    .split(" ")
    .map((word) => `${word[0].toUpperCase()}${word.substring(1)}`)
    .join(" "),
);
i18n.services.formatter.add("uppercase", (value) => value.toUpperCase());

export default i18n;
